import { type Testimonial } from '@common/types/testimonial.type';

import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import { catchError, exhaustMap, map, filter } from 'rxjs/operators';
import TestimonialsActions from './testimonials.actions';
import { TestimonialsHttpService } from './testimonials.http.service';

@Injectable()
export class TestimonialsCollectionEffect {
    private readonly actions$ = inject(Actions);
    private readonly testimonialsHttpService = inject(TestimonialsHttpService);

    public readonly loadTestimonialsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TestimonialsActions.loadCollectionRequest),
            filter(({ courseId }) => Boolean(courseId)),
            exhaustMap(({ courseId }) =>
                this.testimonialsHttpService.getTestimonials(courseId).pipe(
                    map((testimonials: Testimonial[]) =>
                        TestimonialsActions.loadCollectionSuccess({ courseId, testimonials })
                    ),
                    catchError((error) => [TestimonialsActions.loadCollectionFailure({ courseId, error })])
                )
            )
        )
    );
}
